import { useDeviceType } from '@cian/ui-kit';
import { useCallback, useMemo, useRef, useState } from 'react';
import Slider from 'react-slick';
import { ListItem } from 'shared/components/ListItem';
import { TListItemProps } from 'shared/types/list';

type TListItemContainerProps = TListItemProps;

export const ListItemContainer: React.FC<TListItemContainerProps> = props => {
  const sliderRef = useRef<Slider>(null);

  const device = useDeviceType();

  const slidesToShow = useMemo(() => {
    switch (device) {
      case 'desktop':
        return 3;
      case 'tablet':
        return 2;
      default:
        return 1;
    }
  }, [device]);

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const handleCurrentSlideIndex = useCallback((value: number) => {
    setCurrentSlideIndex(value);
  }, []);

  const handleGoNext = useCallback(() => {
    if (sliderRef && sliderRef.current) {
      sliderRef.current.slickNext();
    }
  }, []);

  const handleGoPrev = useCallback(() => {
    if (sliderRef && sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  }, []);

  return (
    <ListItem
      {...props}
      device={device}
      slidesToShow={slidesToShow}
      sliderRef={sliderRef}
      currentSlideIndex={currentSlideIndex}
      onCurrentSlideIndex={handleCurrentSlideIndex}
      onGoNext={handleGoNext}
      onGoPrev={handleGoPrev}
    />
  );
};
